module.exports = __webpack_public_path__ + "img/jp_xhs_2wm.694a9b9.webp";